import * as React from 'react';

function setRefs<T>(ref: React.Ref<T> | null | undefined, value: T | null) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref && 'current' in ref) {
    ref.current = value;
  }
}

export function useForkedRef<T>(
  refA: React.Ref<T> | null | undefined,
  refB: React.Ref<T> | null | undefined
): (instance: T | null) => void {
  return React.useCallback(
    (value: T | null) => {
      if (refA) setRefs(refA, value);
      if (refB) setRefs(refB, value);
    },
    [refA, refB]
  );
}
